import React from 'react';
import PropTypes from 'prop-types';

/* import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Media,
} from 'reactstrap'; */

import Modal from 'reactstrap/lib/Modal';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalFooter from 'reactstrap/lib/ModalFooter';
import Media from 'reactstrap/lib/Media';
import Button from 'reactstrap/lib/Button';

import closeImg from '../../../../images/icons/close.png';
import { FONT_MODE } from '../../../../constants/constants';

const BlockUserModal = React.memo(({
  t, blockUserModal, blockUserSelectedName, toggleBlockUser, blockUserFunction, fontMode,
}) => (
  <Modal container={'div > div'} isOpen={blockUserModal} toggle={() => toggleBlockUser(null, null)} className={`notification old-modal root-font-${fontMode}`}>
    <ModalHeader
      toggle={() => toggleBlockUser(null, null)}
      className="notification-header"
      close={
        <Media src={closeImg} className="notification-header-close" alt="X" onClick={() => toggleBlockUser(null, null)} />
      }
    >{t('common:home.confirm')}</ModalHeader>
    <ModalBody className="notification-body">
      {t('blockPlayerConfirm', { player: blockUserSelectedName })}
    </ModalBody>
    <ModalFooter className="notification-footer">
      <Button className="btn notification-footer-button" onClick={blockUserFunction}>
        {t('yes')}
      </Button>
      <Button type="button" className="btn notification-footer-button" onClick={() => toggleBlockUser(null, null)}>
        {t('no')}
      </Button>
    </ModalFooter>
  </Modal>
));

BlockUserModal.propTypes = {
  blockUserModal: PropTypes.bool,
  blockUserSelectedName: PropTypes.string,
  toggleBlockUser: PropTypes.func.isRequired,
  blockUserFunction: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  fontMode: PropTypes.string,
};

BlockUserModal.defaultProps = {
  blockUserModal: false,
  blockUserSelectedName: null,
  fontMode: FONT_MODE.normal,
};

export default BlockUserModal;
